import type { TranslationKey } from '@/shared/i18n'

export interface CitySuggestion {
  value: string
  key: TranslationKey
}

export const POPULAR_CITIZENSHIPS: Record<string, string[]> = {
  CY: ['RU', 'GB', 'UA', 'IN', 'PH'],
}

export const POPULAR_CITIES: Record<string, CitySuggestion[]> = {
  CY: [
    { value: 'Limassol', key: 'onboarding.city.limassol' },
    { value: 'Nicosia', key: 'onboarding.city.nicosia' },
    { value: 'Larnaca', key: 'onboarding.city.larnaca' },
    { value: 'Paphos', key: 'onboarding.city.paphos' },
  ],
}

export function popularCitizenships(country: string): string[] {
  return POPULAR_CITIZENSHIPS[country] ?? []
}

export function popularCities(country: string): CitySuggestion[] {
  return POPULAR_CITIES[country] ?? []
}
